<div class="permission-menu-container">
    <div class="item-submenu" [class.active]="submenuActive==0" (click)="changeTabRole({tab: 0, name: 'Todos'})" [routerLink]="['/panel-control/config/permission/function']" [queryParams]="{role: 'all'}" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">
        <span>Todos</span>
    </div>
    <div class="item-submenu" *ngFor="let rol of rolesEnable|async" (click)="changeTabRole({tab: rol.id, name: rol.name})" [routerLink]="['/panel-control/config/permission/function']" [queryParams]="{role: rol.id}" routerLinkActive="active" [routerLinkActiveOptions]="{exact:false}">
        <span>{{rol.name}}</span>
    </div>
</div>